<template>
  <v-card style="background-color:#f3f3f3; padding:3px" flat>
    <!--
        <v-row align="center" justify="center">
          <v-col cols="12">

            <v-img src="https://valmontone.digitalseeds.it/immagini/tenant/logo_nero/FP6scvHHKAZ_96NdSOPKsdxOtnNEOwHD.png" contain height="200px">

            </v-img>
          </v-col>

          <v-col cols="12" align="center">Menu del giorno {{currentmenu.data}}{{menuhr}} <v-btn @click="getmenu()">carica</v-btn></v-col>

          <v-col v-for="portata in currentmenu.portate" :key="portata.descrizione"  cols="12" lg="6" align="center">
            <h2 class="font-weight-light" >{{portata.descrizione}}</h2>
            <v-card 
            style="padding:5px; margin-bottom:5px"
            v-for="piatto in portata.piatti" :key="piatto.descrizione">
              <v-row align="center" >
                <v-col  cols="12" sm="2" align="left">
                  <v-img :src="piatto.immagine"  width="100%" aspect-ratio="1"></v-img>
                </v-col>

                <v-col  cols="12" sm="8" align="left" justify="center">
                  <h2 class="font-weight-light">{{piatto.descrizione}}</h2>
                  <div>
                      <span  class="font-weight-light font-italic" v-for="(ingrediente,index) in piatto.ingredienti" :key="index"><span v-if="index>0">,</span> {{ingrediente}}</span></div>
                  
                </v-col>
                <v-col  cols="12" sm="2" align="right">
                    <h4 align="right">€ {{piatto.prezzo}}</h4>
                </v-col>

              </v-row>
            </v-card>
          </v-col>
        </v-row>
    -->
    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-img
          src="https://valmontone.digitalseeds.it/immagini/tenant/logo_nero/FP6scvHHKAZ_96NdSOPKsdxOtnNEOwHD.png"
          contain
          height="200px"
        ></v-img>
      </v-col>
      <v-col cols="12" align="center" v-if="!menuhr">
        <v-btn @click="getmenu()">carica</v-btn>
      </v-col>

      <template v-if="menuhr">
        <v-col v-for="menu in menuhr.menu" :key="menu.descrizione" cols="12">
          {{menu.descrizione||"Menu"}} del {{menuhr.giorno}}
          <v-row>
            <v-col cols="12">
              <h2 class="font-weight-light">PORTATE</h2>
            </v-col>
            <v-col
              v-for="piatto in menu.piatti"
              :key="piatto.descrizione"
              cols="12"
              lg="6"
              align="center"
            >
              <v-card style="padding:5px; margin-bottom:5px">
                <v-row align="center">
                  <v-col cols="12" sm="2" align="left">
                    <v-img
                      :src="piatto.url|| 'http://www.lacervarola.it/wp-content/uploads/2015/09/icona-ristorante.png'"
                      width="100%"
                      aspect-ratio="1"
                    ></v-img>
                  </v-col>

                  <v-col cols="12" sm="8" align="left" justify="center">
                    <h2 class="font-weight-light">{{piatto.descrizione}}</h2>
                    <div>
                      <span
                        class="font-weight-light font-italic"
                        v-for="(ingrediente,index) in piatto.ingredienti"
                        :key="index"
                      >{{index > 0?',':''}} {{ingrediente.descrizione}}{{ingrediente.allergenico=='-1'?'*':''}}</span>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="2" align="right">
                    <!--<v-btn fab><v-icon>mdi-plus</v-icon></v-btn>-->
                    <h3 align="right">€ {{piatto.prezzo/100}}</h3>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </template>
    </v-row>
  </v-card>
</template>

<script>
export default {
  methods: {
    getmenu: function() {
      const payload = {
        Comando: "GetMenuRistorante",
        Giorno: "20200505"
      };
      console.log(payload);
      const me = this;
      this.$store.dispatch("APIRequestHR", payload).then(risp => {
        console.log(risp);
        if (risp.statusText == "OK") {
          me.menuhr = risp.data.RISULTATOJSON;
        }
      });
    }
  },
  mounted() {
    this.getmenu();
  },
  data: () => ({
    menuhr: null,
    currentmenu: {
      id: "m1",
      titolo: "PRANZO",
      data: "21/05/2000",
      portate: [
        {
          descrizione: "primi",
          piatti: [
            {
              id: 1,
              descrizione: "spaghetti al pomodoro",
              immagine:
                "https://images.lacucinaitaliana.it/wp-content/uploads/2015/07/10025843/Spaghetti-al-pomodoro-1600x800.jpg",
              ingredienti: ["pasta", "pomodoro", "basilico", "sale"],
              prezzo: 7.5
            },
            {
              id: 2,
              descrizione: "risotto ai funghi",
              immagine:
                "https://www.lospicchiodaglio.it/img/ricette/risottofunghi.jpg",
              ingredienti: ["riso", "funghi porcini", "prezzemolo", "sale"],
              prezzo: 9.5
            }
          ]
        },
        {
          descrizione: "secondi",
          piatti: [
            {
              id: 1,
              descrizione: "arista al forno",
              immagine:
                "https://www.napolimilionaria.it/wp-content/uploads/2020/02/ricetta-arista-di-maiale.jpg",
              ingredienti: ["maiale", "pepe", "sale", "olio e.v.o."],
              prezzo: 7.5
            },
            {
              id: 2,
              descrizione: "branzino al sale",
              immagine:
                "https://wips.plug.it/cips/buonissimo.org/cms/2012/06/branzino-al-sale.jpg?w=712&a=c&h=406",
              ingredienti: ["branzino", "sale", "olio e.v.o."],
              prezzo: 9.5
            }
          ]
        },
        {
          descrizione: "dessert",
          piatti: [
            {
              id: 1,
              descrizione: "gelato",
              immagine:
                "https://www.ricettedalmondo.it/images/foto-ricette/g/31777-gelato-senza-gelatiera.jpg",
              ingredienti: ["latte", "aromi naturali"],
              prezzo: 7.5
            },
            {
              id: 2,
              descrizione: "tiramisù",
              immagine:
                "https://dpv87w1mllzh1.cloudfront.net/alitalia_discover/attachments/data/000/002/587/original/la-ricetta-classica-del-tiramisu-con-uova-savoiardi-e-mascarpone-1920x1080.jpg?1567093636",
              ingredienti: ["zucchero", "uova", "mascarpone", "caffè"],
              prezzo: 9.5
            }
          ]
        }
      ]
    }
  })
};
</script>